import React from 'react';
import PropTypes from 'prop-types';
import EmbeddedTweet from "../../../Common/components/EmbeddedTweet";
import {getWidgetValue} from "sportinglife-react-common/widgets";
import withErrorBoundary from "../../../Errors/components/withErrorBoundry";

const EmbeddedTweetWidget = ({bodyVisible, widget}) => {
  if (!bodyVisible) {
    return null;
  }

  return (
    <div className="news-article-tweet">
      <EmbeddedTweet html={getWidgetValue(widget, "html")}/>
    </div>
  );
}

EmbeddedTweetWidget.mapProps = (props) => ({
  bodyVisible: props.bodyVisible,
  widget: props.widget
})
EmbeddedTweetWidget.propTypes = {
  bodyVisible: PropTypes.bool,
  widget: PropTypes.object
}

export default withErrorBoundary(EmbeddedTweetWidget);



// WEBPACK FOOTER //
// ./modules/News/components/widgets/EmbeddedTweet.widget.js